import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../helpers/web_to_client'

import styles from './Tabs.css'

const propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    caption: PropTypes.node.isRequired,
    isChecked: PropTypes.bool,
    onClick: PropTypes.func,
    tooltipId: PropTypes.string,
}

class Tab extends React.PureComponent {
    render() {
        const classNameTab = classNames(styles.tab, {
            [styles.isChecked] : this.props.isChecked,
        })

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <div className={styles.item}>
                <div
                    className={classNameTab}
                    onClick={this.props.onClick}
                    onMouseDown={this.props.isChecked ? null : sendClickSoundCommand}
                    onMouseEnter={this.props.isChecked ? null : sendHoverSoundCommand}
                    {...dataAttrs}
                >
                    <div className={styles.caption}>{this.props.caption}</div>
                    <div className={classNames(styles.condition, styles['condition__active'])} />
                    <div className={classNames(styles.condition, styles['condition__hover'])} />
                    <div className={classNames(styles.condition, styles['condition__checked'])} />
                </div>
            </div>
        )
    }
}

Tab.propTypes = propTypes

export default Tab



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Tabs/Tab.jsx